(function () {
  if (!/\/pages\/gingi-universe/.test(location.pathname)) return;
  document.querySelectorAll('.gu-world__photo, .gu-play').forEach(function (el) {
    if (el.innerHTML.indexOf('<imgsrc=') !== -1) {
      el.innerHTML = el.innerHTML.replace(/<imgsrc=/gi, '<img src=');
    }
  });
})();

(function () {
  function syncCollectionOrder() {
    if (!window.location.pathname.includes('/collections/')) return;

    var grid = document.getElementById('productsGrid');
    if (!grid) return;

    var pathParts = window.location.pathname.split('/collections/');
    if (!pathParts[1]) return;
    var collectionHandle = pathParts[1].split('/')[0].split('?')[0];
    if (!collectionHandle) return;

    var urlParams = new URLSearchParams(window.location.search);
    var sortBy = urlParams.get('sort_by');
    var hasFilters = false;
    urlParams.forEach(function (_, key) {
      if (key.indexOf('filter.') === 0) hasFilters = true;
    });
    if (hasFilters || (sortBy && sortBy !== 'manual')) return;

    function getHandleFromItem(item) {
      var btn = item.querySelector('[data-product-handle]');
      if (btn && btn.getAttribute('data-product-handle')) {
        return btn.getAttribute('data-product-handle');
      }
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return null;
      var parts = link.href.split('/products/');
      return parts[1] ? parts[1].split('?')[0] : null;
    }

    fetch('/collections/' + collectionHandle + '/products.json?limit=250')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) return;
        var items = Array.prototype.slice.call(grid.querySelectorAll('.product_grid_1__item'));
        var byHandle = {};
        items.forEach(function (item) {
          var handle = getHandleFromItem(item);
          if (handle) byHandle[handle] = item;
        });
        data.products.forEach(function (product) {
          if (byHandle[product.handle]) {
            grid.appendChild(byHandle[product.handle]);
          }
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCollectionOrder);
  } else {
    syncCollectionOrder();
  }
})();
